import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';
import { General } from 'src/app/constants/constants';

@Component({
  selector: 'app-document-list',
  standalone: false,
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class DocumentListComponent implements OnInit {

  tableConfig: ABCisTableModel;
  documentNumberEvent: number;
  fileViewValue: string;
  rowData: any;
  displayModelDocumentId: boolean = false;
  displayModelFileView: boolean = false;

  constructor(
    private router:Router,
    private activatedRoute:ActivatedRoute,
  ) { }

  ngOnInit() {
    this.setConfiguration();

  }
  setConfiguration() {
    // Route the users filter results. For sharing
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Ocr,
        table: 'null',
        url: 'master-product/unmapped-docs',
        approxamateRowCount: 1000,
        anyParams:true
      },
      colConfig: [
        { field: 'documentId', header: 'Document ID', type: ColumnType.String, isPrimary: true, isLink: true, width: '100px' },
        { field: 'storeName', header: 'Store', type: ColumnType.MultiSelectComplex },
        { field: 'description', header: 'Description', type: ColumnType.String },
        { field: 'purchaseOrderNumber', header: 'Purchase Order Number', type: ColumnType.String }
      ],
      isConfigurable: false,
      isTable:true
    };
  }

  onLinkClick(event) {
    this.rowData = event.value;
    localStorage.setItem(General.LEGACY_SUPPLIER_ID, event.value.legacySupplierId);

    switch (event.column) {
    case 'documentId':
      this.documentIdOnClick();
      this.router.navigate([`${this.rowData.documentId}`,`${this.rowData.fileUuid}`], { relativeTo: this.activatedRoute });
      break;
    case 'documentNumber':
      this.fileViewOnClick();
      break;

    }
  }
  documentIdOnClick() {
    this.documentNumberEvent = this.rowData.documentId;
    this.displayModelDocumentId = true;

  }
  fileViewOnClick() {
    this.fileViewValue = this.rowData.fileUuid;
    this.displayModelFileView = true;
  }
}
